/* AUTAVEX — накидки: логіка */
(function(){
var D=window.AV_NK;if(!D)return;
var K=0.8;
var st={mat:0,dz:1,sew:0,kit:0,col:0,kant:0,pil:0,g:0,note:'',gen:true};
function Q(i){return document.getElementById(i)}
function px(u,w){return D.CDN+u+(u.indexOf('?')>-1?'&':'?')+'width='+w}
function money(v){return Math.round(v).toLocaleString('uk-UA')+' \u20b4'}
function key(){return D.SEW[st.sew][1]}
function kitKey(){return D.KITS[st.kit][0]}
function dzName(){return D.DZ[st.dz][0]}
/* кольори: беремо напряму з AV_NK_COLS, без залежності від порядку файлів */
function COLS(){
  var M=window.AV_NK_COLS;
  if(M){
    var a=M[dzName()];
    if(a&&a.length)return a;
    for(var k in M){if(M[k]&&M[k].length)return M[k]}
  }
  return D.COL||[];
}
function price(k){return (k==='rear')?D.PR.rear:D.PR[key()][k]}
function total(){var s=price(kitKey())||0;if(st.pil)s+=D.PR.pillow*st.pil;return s}
function gal(){
  var L=COLS();
  if(st.gen)return L.map(function(c){return c[2]}).filter(Boolean);
  var c=L[st.col];
  return (c&&c[2])?[c[2]]:[];
}
function dots(arr,sel,k,plain){
  return arr.map(function(c,i){
    var bg=(!plain&&c[2])?c[1]+' url('+px(c[2],240)+') center/cover':c[1];
    return '<span class="sw'+(i===sel?' sel':'')+'"><button type="button" data-'+k+'="'+i+'" title="'+c[0]+'" class="'+(i===sel?'on':'')+'" style="background:'+bg+'"></button>'+(plain?'':'<span class="nm">'+c[0]+'</span>')+'</span>';
  }).join('');
}
function galHTML(){
  var L=gal(),CL=COLS();
  if(!L.length)return '<div class="stage ph">\u0444\u043e\u0442\u043e \u0431\u0443\u0434\u0435 \u0434\u043e\u0434\u0430\u043d\u043e</div>';
  if(st.g>=L.length)st.g=0;
  var cap=st.gen?(dzName()+' \u00b7 '+(st.g+1)+' / '+L.length)
                :(dzName()+' \u00b7 '+(CL[st.col]?CL[st.col][0]:''));
  var back=st.gen?'':'<button type="button" class="gback" data-gen="1">\u2190 \u0432\u0441\u0456 \u043a\u043e\u043b\u044c\u043e\u0440\u0438</button>';
  return '<div class="stage" id="nkStage"><img src="'+px(L[st.g],900)+'" alt="" loading="lazy" decoding="async">'+back+'<span class="cap">'+cap+'</span></div>'+
    (L.length>1?'<div class="thumbs">'+L.map(function(u,i){return '<button type="button" data-g="'+i+'" class="'+(i===st.g?'on':'')+'"><img src="'+px(u,160)+'" alt="" loading="lazy" decoding="async"></button>'}).join('')+'</div>':'');
}
function rows(){
  function row(a,b){return '<div><span>'+a+'</span><span>'+b+'</span></div>'}
  var CL=COLS(),r='';
  r+=row('\u041c\u0430\u0442\u0435\u0440\u0456\u0430\u043b',D.MAT[st.mat][0]);
  r+=row('\u0423\u0437\u043e\u0440',dzName());
  if(kitKey()!=='rear')r+=row('\u0422\u0438\u043f \u043f\u043e\u0448\u0438\u0432\u0443',D.SEW[st.sew][0]);
  r+=row(D.KITS[st.kit][1],money(price(kitKey())));
  if(CL[st.col])r+=row('\u041a\u043e\u043b\u0456\u0440',CL[st.col][0]);
  r+=row('\u041a\u0430\u043d\u0442',D.KANT[st.kant][0]);
  if(st.pil)r+=row('\u041f\u043e\u0434\u0443\u0448\u043a\u0438, '+st.pil+' \u0448\u0442','+'+money(D.PR.pillow*st.pil));
  return r;
}
function draw(){
  var box=Q('nkBody');if(!box)return;
  var CL=COLS(),M=window.AV_NK_COLS||{};
  if(st.col>=CL.length)st.col=0;
  var h='';
  h+='<div class="card">'+galHTML()+'</div>';
  h+='<div class="card">';
  h+='<h3>\u041c\u0430\u0442\u0435\u0440\u0456\u0430\u043b<b>'+D.MAT[st.mat][0]+'</b></h3><div class="cats">'+
     D.MAT.map(function(m,i){return '<button type="button" data-mat="'+i+'" class="'+(i===st.mat?'on':'')+'"><b>'+m[0]+'</b><span>'+m[1]+'</span></button>'}).join('')+'</div>';
  h+='<h3>\u0423\u0437\u043e\u0440<b>'+dzName()+'</b></h3><div class="dzg">'+
     D.DZ.map(function(d,i){
       var arr=M[d[0]],pic=d[1]||((arr&&arr.length)?arr[0][2]:'');
       if(!pic){var f=COLS();pic=(f&&f.length&&f[0][2])?f[0][2]:''}
       var ph=pic?'<span class="ph"><img src="'+px(pic,320)+'" alt="" loading="lazy"></span>':'<span class="ph ph0">\u0444\u043e\u0442\u043e</span>';
       return '<button type="button" data-dz="'+i+'" class="'+(i===st.dz?'on':'')+'">'+ph+'<b>'+d[0]+'</b></button>'}).join('')+'</div>';
  if(kitKey()!=='rear'){
    h+='<h3>\u0422\u0438\u043f \u043f\u043e\u0448\u0438\u0432\u0443<b>'+D.SEW[st.sew][0]+'</b></h3><div class="dzg">'+
       D.SEW.map(function(s,i){
         var ph=s[3]?'<span class="ph"><img src="'+px(s[3],320)+'" alt="" loading="lazy"></span>':'<span class="ph ph0">\u0444\u043e\u0442\u043e</span>';
         return '<button type="button" data-sew="'+i+'" class="'+(i===st.sew?'on':'')+'">'+ph+'<b>'+s[0]+'</b><span class="tag">'+s[2]+'</span></button>'}).join('')+'</div>';
  }
  h+='<h3>\u041a\u043e\u043c\u043f\u043b\u0435\u043a\u0442\u0430\u0446\u0456\u044f<b>'+D.KITS[st.kit][1]+'</b></h3><div class="kits">'+
     D.KITS.map(function(k,i){
       var p=(k[0]==='rear')?D.PR.rear:D.PR[key()][k[0]];
       var pic=k[3]?'<img src="'+px(k[3],260)+'" alt="" loading="lazy">':'';
       return '<button type="button" data-kit="'+i+'" class="kit'+(i===st.kit?' on':'')+'">'+
         '<span class="pic">'+pic+'</span><span class="t"><b>'+k[1]+'</b><span class="d">'+k[2]+'</span></span>'+
         '<span class="p"><span class="old">'+money(p/K)+'</span><span class="now">'+money(p)+'</span></span></button>'}).join('')+'</div>';
  if(kitKey()==='rear')h+='<p class="note">\u0417\u0430\u0434\u043d\u0456\u0439 \u043a\u043e\u043c\u043f\u043b\u0435\u043a\u0442 \u043a\u043e\u0448\u0442\u0443\u0454 \u043e\u0434\u043d\u0430\u043a\u043e\u0432\u043e \u0434\u043b\u044f \u0432\u0441\u0456\u0445 \u0442\u0438\u043f\u0456\u0432 \u043f\u043e\u0448\u0438\u0432\u0443.</p>';
  h+='<h3>\u041a\u043e\u043b\u0456\u0440 \u043d\u0430\u043a\u0438\u0434\u043e\u043a<b>'+(CL[st.col]?CL[st.col][0]:'')+'</b></h3><div class="dots">'+dots(CL,st.col,'col',false)+'</div>'+
     '<p class="hint">\u041d\u0430\u0442\u0438\u0441\u043d\u0456\u0442\u044c \u043a\u043e\u043b\u0456\u0440 \u2014 \u0433\u0430\u043b\u0435\u0440\u0435\u044f \u0437\u0433\u043e\u0440\u0438 \u043f\u043e\u043a\u0430\u0436\u0435 \u0441\u0430\u043c\u0435 \u0446\u0435\u0439 \u043a\u043e\u043b\u0456\u0440</p>';
  h+='<h3>\u041a\u043e\u043b\u0456\u0440 \u043a\u0430\u043d\u0442\u0430<b>'+D.KANT[st.kant][0]+'</b></h3><div class="dots thr">'+dots(D.KANT,st.kant,'kant',true)+'</div>';
  h+='<h3>\u0414\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u043e</h3>';
  h+='<div class="opt'+(st.pil>0?' on':'')+'" data-opt="pil"><span class="box"></span>'+
     (D.PILLOW?'<span class="pic"><img src="'+px(D.PILLOW,220)+'" alt="" loading="lazy"></span>':'<span class="pic ph0">\u0444\u043e\u0442\u043e</span>')+
     '<span class="t"><b>\u041f\u043e\u0434\u0443\u0448\u043a\u0438-\u043f\u0456\u0434\u0433\u043e\u043b\u0456\u0432\u043d\u0438\u043a\u0438</b><span class="d">\u043a\u043e\u043b\u0456\u0440 \u2014 \u044f\u043a \u0443 \u043e\u0431\u0440\u0430\u043d\u043e\u0433\u043e \u043a\u043e\u043c\u043f\u043b\u0435\u043a\u0442\u0430</span></span>'+
     '<span class="p">380 \u20b4 / \u0448\u0442</span></div>';
  if(st.pil>0)h+='<div class="qty"><span>\u041a\u0456\u043b\u044c\u043a\u0456\u0441\u0442\u044c \u043f\u043e\u0434\u0443\u0448\u043e\u043a</span><span class="q"><button type="button" data-pq="-1">\u2212</button><b>'+st.pil+'</b><button type="button" data-pq="1">+</button><i>+'+money(D.PR.pillow*st.pil)+'</i></span></div>';
  h+='<h3>\u041a\u043e\u043c\u0435\u043d\u0442\u0430\u0440 \u0434\u043e \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f</h3><textarea id="nkNote" placeholder="\u041c\u0430\u0440\u043a\u0430 \u0442\u0430 \u043c\u043e\u0434\u0435\u043b\u044c \u0430\u0432\u0442\u043e, \u043f\u043e\u0431\u0430\u0436\u0430\u043d\u043d\u044f">'+(st.note||'')+'</textarea>';
  h+='<div class="calc">'+rows()+'</div>';
  var t=total();
  h+='<div class="sum"><span class="l">\u0420\u0430\u0437\u043e\u043c</span><span class="r"><span class="old">'+money(t/K)+'</span><span class="v">'+money(t)+'</span></span></div>';
  h+='<div class="acts"><button type="button" class="add">\u0414\u043e\u0434\u0430\u0442\u0438 \u0432 \u043a\u043e\u0448\u0438\u043a</button><button type="button" class="buy">\u041e\u0444\u043e\u0440\u043c\u0438\u0442\u0438 \u0442\u0430 \u043e\u043f\u043b\u0430\u0442\u0438\u0442\u0438</button></div>';
  h+='<div class="msg" id="nkMsg"></div></div>';
  box.innerHTML=h;
}
function props(){
  var CL=COLS(),p={};
  p['\u041c\u0430\u0442\u0435\u0440\u0456\u0430\u043b']=D.MAT[st.mat][0];
  p['\u0423\u0437\u043e\u0440']=dzName();
  if(kitKey()!=='rear')p['\u0422\u0438\u043f \u043f\u043e\u0448\u0438\u0432\u0443']=D.SEW[st.sew][0];
  p['\u041a\u043e\u043c\u043f\u043b\u0435\u043a\u0442\u0430\u0446\u0456\u044f']=D.KITS[st.kit][1];
  if(CL[st.col])p['\u041a\u043e\u043b\u0456\u0440 \u043d\u0430\u043a\u0438\u0434\u043e\u043a']=CL[st.col][0];
  p['\u041a\u043e\u043b\u0456\u0440 \u043a\u0430\u043d\u0442\u0430']=D.KANT[st.kant][0];
  if(st.pil){p['\u041f\u043e\u0434\u0443\u0448\u043a\u0438-\u043f\u0456\u0434\u0433\u043e\u043b\u0456\u0432\u043d\u0438\u043a\u0438']=st.pil+' \u0448\u0442';
    if(CL[st.col])p['\u041a\u043e\u043b\u0456\u0440 \u043f\u043e\u0434\u0443\u0448\u043e\u043a']='\u044f\u043a \u0443 \u043a\u043e\u043c\u043f\u043b\u0435\u043a\u0442\u0430: '+CL[st.col][0]}
  if(st.note)p['\u041a\u043e\u043c\u0435\u043d\u0442\u0430\u0440']=st.note;
  p['\u0421\u0443\u043c\u0430 \u0437\u0430\u043c\u043e\u0432\u043b\u0435\u043d\u043d\u044f']=money(total());
  return p;
}
function msg(k,h){var m=Q('nkMsg');if(m){m.className='msg '+k;m.innerHTML=h}}
function send(mode,btn){
  var pr=props(),items=[];
  var id=(kitKey()==='rear')?D.V.rear:D.V[key()+'_'+kitKey()];
  if(!id){msg('err','\u041e\u0431\u0435\u0440\u0456\u0442\u044c \u043a\u043e\u043c\u043f\u043b\u0435\u043a\u0442\u0430\u0446\u0456\u044e');return}
  items.push({id:id,quantity:1,properties:pr});
  if(st.pil)items.push({id:D.V.pillow,quantity:st.pil,properties:pr});
  if(btn)btn.disabled=true;
  msg('ok','\u0414\u043e\u0434\u0430\u0454\u043c\u043e\u2026');
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:items})})
   .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d}})})
   .then(function(res){
     if(btn)btn.disabled=false;
     if(!res.ok){msg('err','\u041d\u0435 \u0432\u0434\u0430\u043b\u043e\u0441\u044c \u0434\u043e\u0434\u0430\u0442\u0438: '+((res.d&&(res.d.description||res.d.message))||''));return}
     if(mode==='buy'){location.href='/cart';return}
     msg('ok','\u0414\u043e\u0434\u0430\u043d\u043e \u0432 \u043a\u043e\u0448\u0438\u043a \u00b7 '+money(total())+' \u2014 <a href="/cart">\u043f\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u043a\u043e\u0448\u0438\u043a</a>');
   }).catch(function(){if(btn)btn.disabled=false;msg('err','\u041d\u0435\u043c\u0430\u0454 \u0437\u02bc\u0454\u0434\u043d\u0430\u043d\u043d\u044f. \u041e\u043d\u043e\u0432\u0456\u0442\u044c \u0441\u0442\u043e\u0440\u0456\u043d\u043a\u0443.')});
}
function lb(src){
  var b=Q('nkLb');
  if(!b){
    b=document.createElement('div');b.id='nkLb';
    b.innerHTML='<img alt=""><button class="x" type="button">\u2715</button><button class="nv pv" type="button">\u2039</button><button class="nv nx" type="button">\u203a</button><span class="cnt"></span>';
    document.body.appendChild(b);
    b.addEventListener('click',function(e){
      if(e.target.closest('.pv')){step(-1);return}
      if(e.target.closest('.nx')){step(1);return}
      if(e.target.closest('.x')||e.target===b){b.classList.remove('on');document.body.style.overflow=''}
    });
    var x0=null;
    b.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
    b.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>45)step(dx<0?1:-1);x0=null},{passive:true});
    document.addEventListener('keydown',function(e){
      if(!b.classList.contains('on'))return;
      if(e.key==='Escape'){b.classList.remove('on');document.body.style.overflow=''}
      if(e.key==='ArrowLeft')step(-1);
      if(e.key==='ArrowRight')step(1);
    });
  }
  b.querySelector('img').src=src;
  var L=gal();
  b.querySelector('.cnt').textContent=L.length>1?((st.g+1)+' / '+L.length):'';
  b.classList.add('on');document.body.style.overflow='hidden';
}
function step(d){var L=gal();if(L.length<2)return;st.g=(st.g+d+L.length)%L.length;draw();lb(px(L[st.g],1600))}
document.addEventListener('click',function(e){
  if(!Q('nk'))return;
  var y=window.scrollY,t=e.target;
  if(t.closest('#nkBody [data-gen]')){st.gen=true;st.g=0;draw();window.scrollTo(0,y);return}
  var b=t.closest('#nkBody [data-mat],#nkBody [data-dz],#nkBody [data-sew],#nkBody [data-kit],#nkBody [data-col],#nkBody [data-kant],#nkBody [data-g],#nkBody [data-opt],#nkBody [data-pq]');
  if(b){
    var d=b.dataset;
    if(d.mat!==undefined)st.mat=+d.mat;
    if(d.dz!==undefined){st.dz=+d.dz;st.col=0;st.g=0;st.gen=true}
    if(d.sew!==undefined)st.sew=+d.sew;
    if(d.kit!==undefined)st.kit=+d.kit;
    if(d.col!==undefined){st.col=+d.col;st.gen=false;st.g=0}
    if(d.kant!==undefined)st.kant=+d.kant;
    if(d.g!==undefined)st.g=+d.g;
    if(d.opt==='pil')st.pil=st.pil>0?0:2;
    if(d.pq!==undefined)st.pil=Math.max(1,Math.min(8,st.pil+(+d.pq)));
    var n=Q('nkNote');if(n)st.note=n.value.trim();
    draw();window.scrollTo(0,y);return;
  }
  if(t.closest('#nkStage')){var L=gal();if(L.length)lb(px(L[st.g],1600));return}
  var pic=t.closest('#nkBody .pic img, #nkBody .ph img');
  if(pic){lb((pic.getAttribute('src')||'').replace(/([?&])width=\d+/,'$1width=1100'));return}
  var act=t.closest('#nkBody .acts button');
  if(act){send(act.className==='buy'?'buy':'add',act);return}
  var nav=t.closest('#nkNav a');
  if(nav){
    var tab=nav.dataset.t,links=document.querySelectorAll('#nkNav a'),secs=document.querySelectorAll('#nk .sec');
    for(var i=0;i<links.length;i++)links[i].className=(links[i]===nav?'on':'');
    for(var j=0;j<secs.length;j++)secs[j].className='sec'+(secs[j].id==='nk-'+tab?' on':'');
    window.scrollTo({top:0,behavior:'smooth'});
  }
},false);
document.addEventListener('input',function(e){if(e.target.id==='nkNote')st.note=e.target.value.trim()},false);
function boot(){if(Q('nk'))draw()}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot)}else{boot()}
})();
